//Recommended articles slider
function recommended_articles_slider(el) {
    el.slick( {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 3200,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false
                }
            },
            {
                breakpoint: 680,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false
                }
            }
        ]
    } );
}

jQuery( document ).ready( function ( $ ) {
    let el = $( '.recommended-articles-section .blog-list__wrapper' ).not( '.slick-initialized' );
    if ( el.length > 0 ) {
        el.each( function () {
            let sl = $( this );
            if ( sl.hasClass( 'ajax-relevant-posts' ) ) {
                let post_id = sl.data( 'post-id' );
                $.ajax( {
                    url: window.options.ajax_url,
                    data: {post_id: post_id, action: 'get_posts_random_order'},
                    type: 'POST',
                    success: function ( respons ) {
                        sl.html( respons.data );
                        recommended_articles_slider( sl );
                    }
                } );
            } else {
                recommended_articles_slider( sl );
            }
        } )
    }
} );